import { trackAnchorLinkClick } from '../tracking/trackingLayer';

export default class AnchorLinkElement extends HTMLElement {
  connectedCallback() {
    this.click = () => {
      const element = document.getElementById(this.getAttribute('target-id'));
      window.scrollTo({
        top: element.offsetTop - (this.getAttribute('padding') || 0),
        behavior: 'smooth',
      });
      trackAnchorLinkClick();
    };

    this.addEventListener('click', this.click);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.click);
  }
}

customElements.define('bewerten-anchor-link', AnchorLinkElement);
